/**
 * Lightweight CSS-only floating hearts — replaces the heavy Three.js Canvas.
 * Uses GPU-composited CSS animations (transform + opacity) for smooth 60 fps.
 */

const hearts = [
  { left: '8%',  top: '15%', size: 18, delay: '0s',   duration: '7s',  color: 'hsl(var(--primary) / 0.25)' },
  { left: '85%', top: '20%', size: 14, delay: '1.5s', duration: '9s',  color: 'hsl(270 60% 70% / 0.2)' },
  { left: '20%', top: '70%', size: 10, delay: '3s',   duration: '8s',  color: 'hsl(142 60% 70% / 0.2)' },
  { left: '75%', top: '60%', size: 12, delay: '0.8s', duration: '10s', color: 'hsl(350 70% 70% / 0.2)' },
  { left: '50%', top: '40%', size: 8,  delay: '2s',   duration: '11s', color: 'hsl(var(--primary) / 0.15)' },
];

const bubbles = [
  { left: '90%', top: '25%', size: 10, delay: '0.5s', duration: '12s', color: 'hsl(270 60% 80% / 0.15)' },
  { left: '5%',  top: '55%', size: 12, delay: '2.5s', duration: '14s', color: 'hsl(270 50% 85% / 0.12)' },
  { left: '40%', top: '80%', size: 7,  delay: '1s',   duration: '13s', color: 'hsl(45 90% 60% / 0.12)' },
];

export function FloatingHeartsScene() {
  return (
    <div
      className="fixed inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: -1, opacity: 0.35 }}
      aria-hidden="true"
    >
      {hearts.map((h, i) => (
        <span
          key={`h${i}`}
          className="absolute animate-float-heart"
          style={{
            left: h.left,
            top: h.top,
            width: h.size,
            height: h.size,
            animationDelay: h.delay,
            animationDuration: h.duration,
            color: h.color,
          }}
        >
          {/* CSS heart using pseudo-approach via inline SVG for simplicity */}
          <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </svg>
        </span>
      ))}

      {bubbles.map((b, i) => (
        <span
          key={`b${i}`}
          className="absolute rounded-full animate-float-bubble"
          style={{
            left: b.left,
            top: b.top,
            width: b.size,
            height: b.size,
            backgroundColor: b.color,
            animationDelay: b.delay,
            animationDuration: b.duration,
          }}
        />
      ))}
    </div>
  );
}
